import type { FC } from 'react';
import React from 'react';

import styled from '@emotion/styled';

import { COLORS, mq } from '@clutter/clean';

import type { PageQuery } from '@graphql/platform';

import { PageExternalContent } from './shared';

const PageBlurbExternalContent = styled(PageExternalContent)`
  && p {
    ${mq({
      fontSize: ['18px', '20px', '24px'],
      lineHeight: ['140%', '140%', '120%'],
      marginTop: ['10px', '20px'],
    })}
  }

  && h1,
  && h2,
  && h3,
  && h4,
  && h5,
  && h6 {
    ${mq({
      margin: ['0 0 18px', '0 0 30px'],
    })}
  }
`;

const PageBlurbContainer = styled.div`
  background: ${COLORS.tealBackground};
  display: flex;
  justify-content: center;
`;

const PageBlurbContent = styled.div`
  display: flex;
  width: 1280px;
  max-width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  ${mq({
    height: ['auto', '339px'],
    padding: ['48px 24px', '0 100px'],
    gap: ['18px', '30px'],
  })}
`;

export const PageBlurb: FC<{
  page: PageQuery['page'];
}> = ({ page }) => {
  if (!page) throw new Error('missing page');

  return (
    <PageBlurbContainer>
      <PageBlurbContent>
        <PageBlurbExternalContent
          dangerouslySetInnerHTML={{ __html: page.blurb }}
        />
      </PageBlurbContent>
    </PageBlurbContainer>
  );
};
